import { render, staticRenderFns } from "./GalleryComments.vue?vue&type=template&id=9dc881c6&"
import script from "./GalleryComments.vue?vue&type=script&lang=js&"
export * from "./GalleryComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports